(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (() => {
    const setupPawmoreHeaderDrawer = (drawer) => {
      if (drawer.dataset.pawmoreMenuReady === 'true') return;

      const details = drawer.querySelector(':scope > details');
      const summary = details?.querySelector(':scope > summary');
      const menu = details?.querySelector(':scope > #menu-drawer');
      const closeButton = menu?.querySelector('.pawmore-menu-drawer__close');

      if (!details || !summary || !menu || !closeButton) return;

      drawer.dataset.pawmoreMenuReady = 'true';

      const html = document.documentElement;
      const body = document.body;
      const transitionDuration = () =>
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 150;

      const setHeaderPosition = () => {
        drawer.header = drawer.closest('.section-header');
        if (!drawer.header) return;

        html.style.setProperty('--header-bottom-position', `${drawer.header.getBoundingClientRect().bottom}px`);
        html.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      };

      const lockPage = () => {
        if (drawer.pawmorePageLock) return;

        drawer.pawmorePageLock = {
          htmlOverflow: html.style.overflow,
          htmlPosition: html.style.position,
          bodyOverflow: body.style.overflow,
          bodyPosition: body.style.position,
        };

        html.style.overflow = 'hidden';
        html.style.position = 'fixed';
        body.style.overflow = 'hidden';
        body.style.position = 'fixed';
        body.classList.add('pawmore-menu-locked');
      };

      const unlockPage = () => {
        if (!drawer.pawmorePageLock) return;

        html.style.overflow = drawer.pawmorePageLock.htmlOverflow;
        html.style.position = drawer.pawmorePageLock.htmlPosition;
        body.style.overflow = drawer.pawmorePageLock.bodyOverflow;
        body.style.position = drawer.pawmorePageLock.bodyPosition;
        body.classList.remove('pawmore-menu-locked');
        drawer.pawmorePageLock = null;
      };

      drawer.onResize = setHeaderPosition;
      drawer.pawmoreSummaryKeydown = (event) => {
        if (!['ENTER', 'SPACE'].includes(event.code.toUpperCase())) return;

        event.preventDefault();
        summary.click();
      };
      summary.addEventListener('keydown', drawer.pawmoreSummaryKeydown);

      drawer.openMenuDrawer = function (summaryElement) {
        window.clearTimeout(this.pawmoreCloseTimer);
        window.clearTimeout(this.pawmoreBodyClickTimer);
        window.cancelAnimationFrame(this.pawmoreOpenRaf);
        window.cancelAnimationFrame(this.pawmoreOpenRafSecond);
        this.pawmoreCloseTimer = null;

        setHeaderPosition();
        this.header?.classList.add('menu-open');
        summaryElement.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-hidden', 'false');
        body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
        lockPage();

        window.addEventListener('resize', this.onResize);
        this.onBodyClickHandler = this.onBodyClickHandler || this.onBodyClick.bind(this);
        this.pawmoreBodyClickTimer = window.setTimeout(() => {
          document.addEventListener('click', this.onBodyClickHandler);
        });

        this.pawmoreOpenRaf = window.requestAnimationFrame(() => {
          this.pawmoreOpenRafSecond = window.requestAnimationFrame(() => {
            details.classList.add('menu-opening');
            trapFocus(menu, closeButton);
          });
        });
      };

      drawer.closeMenuDrawer = function (event, elementToFocus = summary) {
        if (!elementToFocus || this.pawmoreCloseTimer) return;

        window.clearTimeout(this.pawmoreBodyClickTimer);
        window.cancelAnimationFrame(this.pawmoreOpenRaf);
        window.cancelAnimationFrame(this.pawmoreOpenRafSecond);
        details.classList.remove('menu-opening');
        details.querySelectorAll('details').forEach((nestedDetails) => {
          nestedDetails.removeAttribute('open');
          nestedDetails.classList.remove('menu-opening');
        });
        details.querySelectorAll('.submenu-open').forEach((submenu) => submenu.classList.remove('submenu-open'));

        summary.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        removeTrapFocus();
        if (menu.contains(document.activeElement)) document.activeElement.blur();

        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('click', this.onBodyClickHandler);

        this.pawmoreCloseTimer = window.setTimeout(() => {
          details.removeAttribute('open');
          this.header?.classList.remove('menu-open');
          body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
          unlockPage();
          elementToFocus.focus();
          this.pawmoreCloseTimer = null;
        }, transitionDuration());
      };

      drawer.pawmoreMenuCleanup = () => {
        window.clearTimeout(drawer.pawmoreCloseTimer);
        window.clearTimeout(drawer.pawmoreBodyClickTimer);
        window.cancelAnimationFrame(drawer.pawmoreOpenRaf);
        window.cancelAnimationFrame(drawer.pawmoreOpenRafSecond);
        window.removeEventListener('resize', drawer.onResize);
        document.removeEventListener('click', drawer.onBodyClickHandler);
        summary.removeEventListener('keydown', drawer.pawmoreSummaryKeydown);
        removeTrapFocus();
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        drawer.header?.classList.remove('menu-open');
        body.classList.remove(`overflow-hidden-${drawer.dataset.breakpoint}`);
        unlockPage();
      };
    };

    const setupPawmoreHeaderDrawers = () => {
      customElements.whenDefined('header-drawer').then(() => {
        document
          .querySelectorAll('header-drawer:not([data-pawmore-menu-ready="true"])')
          .forEach(setupPawmoreHeaderDrawer);
      });
    };

    setupPawmoreHeaderDrawers();
    document.addEventListener('shopify:section:load', setupPawmoreHeaderDrawers);
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelector('header-drawer')?.pawmoreMenuCleanup?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawmore-customer-proof-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.PawmoreCustomerProofCarouselLoaded) return;
    window.PawmoreCustomerProofCarouselLoaded = true;

    const instances = new WeakMap();
    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const init = (root = document) => {
      root.querySelectorAll('[data-pawmore-customer-proof-carousel]').forEach((carousel) => {
        if (carousel.dataset.pawmoreCustomerProofReady === 'true') return;

        const track = carousel.querySelector('[data-pawmore-customer-proof-track]');
        const cards = Array.from(carousel.querySelectorAll('[data-pawmore-customer-proof-card]'));
        const dots = Array.from(carousel.querySelectorAll('[data-pawmore-customer-proof-dot]'));
        if (!track || cards.length < 2 || !dots.length) return;

        const controller = new AbortController();
        const { signal } = controller;

        const setActiveDot = (activeIndex) => {
          dots.forEach((dot, index) => {
            const isActive = index === activeIndex;
            dot.classList.toggle('is-active', isActive);
            if (isActive) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        };

        const updateDots = () => {
          const trackLeft = track.getBoundingClientRect().left;
          let activeIndex = 0;
          let shortestDistance = Infinity;

          cards.forEach((card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
            if (distance < shortestDistance) {
              shortestDistance = distance;
              activeIndex = index;
            }
          });

          setActiveDot(Math.min(activeIndex, dots.length - 1));
        };

        let scrollFrame = null;
        track.addEventListener('scroll', () => {
          if (scrollFrame) return;
          scrollFrame = window.requestAnimationFrame(() => {
            updateDots();
            scrollFrame = null;
          });
        }, { passive: true, signal });

        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            const card = cards[index];
            if (!card) return;

            card.scrollIntoView({
              behavior: prefersReducedMotion() ? 'auto' : 'smooth',
              block: 'nearest',
              inline: 'start'
            });
            setActiveDot(index);
          }, { signal });
        });

        window.addEventListener('resize', updateDots, { passive: true, signal });
        updateDots();
        carousel.dataset.pawmoreCustomerProofReady = 'true';

        instances.set(carousel, {
          destroy: () => {
            controller.abort();
            window.cancelAnimationFrame(scrollFrame);
            instances.delete(carousel);
            delete carousel.dataset.pawmoreCustomerProofReady;
          }
        });
      });
    };

    const destroy = (root = document) => {
      root.querySelectorAll('[data-pawmore-customer-proof-carousel]').forEach((carousel) => {
        instances.get(carousel)?.destroy();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawmore-guarantee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.PawmoreGuaranteeLoaded) return;
    window.PawmoreGuaranteeLoaded = true;

    const getHeroTarget = () => (
      document.querySelector('#pawmore-product-details .shop-image-container')
      || document.querySelector('#pawmore-product-details .shop-gallery-viewport')
      || document.querySelector('#pawmore-product-details .pawmore-product-details__media')
      || document.querySelector('#pawmore-product-details .shop-carousel-container')
      || document.querySelector('#pawmore-product-details')
    );

    document.addEventListener('click', (event) => {
      const eventTarget = event.target instanceof Element ? event.target : event.target?.parentElement;
      const trigger = eventTarget?.closest('[data-pawmore-guarantee-hero-jump]');
      if (!trigger) return;

      const target = getHeroTarget();
      if (!target) return;

      event.preventDefault();
      event.stopPropagation();

      const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
      const top = Math.max(0, targetTop - 6);
      const html = document.documentElement;
      const body = document.body;
      const previousHtmlScrollBehavior = html.style.scrollBehavior;
      const previousBodyScrollBehavior = body ? body.style.scrollBehavior : '';

      html.style.scrollBehavior = 'auto';
      if (body) body.style.scrollBehavior = 'auto';
      window.scrollTo({ top, behavior: 'instant' });

      window.requestAnimationFrame(() => {
        window.scrollTo({ top, behavior: 'instant' });
        html.style.scrollBehavior = previousHtmlScrollBehavior;
        if (body) body.style.scrollBehavior = previousBodyScrollBehavior;
      });
    }, { capture: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawmore-media-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.PawmoreMediaStoryLoaded) return;
    window.PawmoreMediaStoryLoaded = true;

    const observers = new WeakMap();
    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const resetVideo = (video) => {
      video.pause();

      const seekToStart = () => {
        try {
          video.currentTime = 0;
        } catch {}
      };

      if (video.readyState >= 1) {
        seekToStart();
      } else {
        video.addEventListener('loadedmetadata', seekToStart, { once: true });
      }

      video.dataset.pawmoreMediaStoryPlaying = 'false';
    };

    const playVideo = (video) => {
      if (video.dataset.pawmoreMediaStoryPlaying === 'true') return;
      video.dataset.pawmoreMediaStoryPlaying = 'true';

      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          video.dataset.pawmoreMediaStoryPlaying = 'false';
        });
      }
    };

    const init = (root = document) => {
      root.querySelectorAll('[data-pawmore-media-story-viewport-video]').forEach((video) => {
        if (video.dataset.pawmoreMediaStoryReady === 'true') return;

        resetVideo(video);
        video.dataset.pawmoreMediaStoryReady = 'true';

        if (prefersReducedMotion()) return;
        if (!('IntersectionObserver' in window)) {
          playVideo(video);
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.45) {
              playVideo(video);
            } else if (!entry.isIntersecting || entry.intersectionRatio <= 0.05) {
              resetVideo(video);
            }
          });
        }, { threshold: [0, 0.05, 0.45] });

        observer.observe(video);
        observers.set(video, observer);
      });
    };

    const destroy = (root = document) => {
      root.querySelectorAll('[data-pawmore-media-story-viewport-video]').forEach((video) => {
        observers.get(video)?.disconnect();
        observers.delete(video);
        resetVideo(video);
        delete video.dataset.pawmoreMediaStoryReady;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawmore-ugc-video-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.PawmoreUgcVideoCarouselLoaded) return;
    window.PawmoreUgcVideoCarouselLoaded = true;

    const instances = new WeakMap();
    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const init = (root = document) => {
      root.querySelectorAll('[data-pawmore-ugc-carousel]').forEach((carousel) => {
        if (carousel.dataset.pawmoreUgcReady === 'true') return;

        const viewport = carousel.querySelector('[data-pawmore-ugc-viewport]');
        const cards = Array.from(carousel.querySelectorAll('[data-pawmore-ugc-card]'));
        const previousButton = carousel.querySelector('[data-pawmore-ugc-previous]');
        const nextButton = carousel.querySelector('[data-pawmore-ugc-next]');
        const status = carousel.querySelector('[data-pawmore-ugc-status]');
        if (!viewport || cards.length < 2) return;

        const controller = new AbortController();
        const { signal } = controller;
        const videos = cards.map((card) => card.querySelector('[data-pawmore-ugc-video]'));
        let activeIndex = Math.max(0, cards.findIndex((card) => card.classList.contains('is-active')));
        let intersectionObserver = null;
        let isInView = false;
        let playTimer = null;
        let pointerStart = null;
        let resizeFrame = null;
        let suppressNextClick = false;
        const firstFrameTime = 0.001;

        const normalizeIndex = (index) => ((index % cards.length) + cards.length) % cards.length;

        const primeFirstFrame = (video) => {
          const seekToFirstFrame = () => {
            if (!video.paused) return;
            try {
              video.currentTime = firstFrameTime;
            } catch {}
          };

          if (video.readyState >= 1) seekToFirstFrame();
          else video.addEventListener('loadedmetadata', seekToFirstFrame, { once: true, signal });
        };

        const updateVolumeControl = (card, video, index) => {
          const soundToggle = card.querySelector('[data-pawmore-ugc-sound]');
          const volumeSlider = card.querySelector('[data-pawmore-ugc-volume]');
          if (!soundToggle || !volumeSlider || !video) return;

          const displayedVolume = video.muted ? 0 : video.volume;
          const volumeLevel = displayedVolume <= 0 ? 'muted' : displayedVolume < 0.5 ? 'low' : 'high';
          const muteLabel = carousel.dataset.muteLabel || 'Mute video';
          const unmuteLabel = carousel.dataset.unmuteLabel || 'Unmute video';
          const fillPercentage = Math.round(displayedVolume * 100);

          soundToggle.dataset.volumeLevel = volumeLevel;
          soundToggle.setAttribute('aria-label', `${volumeLevel === 'muted' ? unmuteLabel : muteLabel} ${index + 1}`);
          volumeSlider.value = String(displayedVolume);
          volumeSlider.style.background = `linear-gradient(to top, #ffffff ${fillPercentage}%, rgba(255, 255, 255, 0.3) ${fillPercentage}%)`;
        };

        const updateCardControls = () => {
          cards.forEach((card, index) => {
            const video = videos[index];
            const playToggle = card.querySelector('[data-pawmore-ugc-toggle]');
            const isActive = index === activeIndex;
            const isPlaying = Boolean(video && !video.paused && !video.ended);

            card.dataset.playing = isPlaying ? 'true' : 'false';
            card.classList.toggle('is-active', isActive);
            if (isActive) card.setAttribute('aria-current', 'true');
            else card.removeAttribute('aria-current');

            if (playToggle) {
              playToggle.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
              const playLabel = carousel.dataset.playLabel || 'Play video';
              const pauseLabel = carousel.dataset.pauseLabel || 'Pause video';
              const selectLabel = carousel.dataset.selectLabel || 'Select and play video';
              playToggle.setAttribute(
                'aria-label',
                `${isActive ? (isPlaying ? pauseLabel : playLabel) : selectLabel} ${index + 1}`
              );
            }

            updateVolumeControl(card, video, index);
          });
        };

        const pauseVideos = ({ reset = false } = {}) => {
          window.clearTimeout(playTimer);
          playTimer = null;

          videos.forEach((video) => {
            if (!video) return;
            video.pause();
            if (!reset) return;

            const seekToStart = () => {
              try {
                video.currentTime = firstFrameTime;
              } catch {}
            };

            if (video.readyState >= 1) seekToStart();
            else video.addEventListener('loadedmetadata', seekToStart, { once: true, signal });
          });

          updateCardControls();
        };

        const playActiveVideo = ({ restart = false, delay = 0 } = {}) => {
          const video = videos[activeIndex];
          if (!video) return;

          window.clearTimeout(playTimer);
          playTimer = null;

          const startPlayback = () => {
            videos.forEach((candidate, index) => {
              if (!candidate || index === activeIndex) return;
              candidate.pause();
            });

            if (restart) {
              try {
                video.currentTime = firstFrameTime;
              } catch {}
            }

            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(updateCardControls);
            }
          };

          if (delay > 0) playTimer = window.setTimeout(startPlayback, delay);
          else startPlayback();
        };

        const layoutCards = ({ instant = false } = {}) => {
          const activeCard = cards[activeIndex];
          const cardWidth = activeCard?.getBoundingClientRect().width || 0;
          const carouselStyles = window.getComputedStyle(carousel);
          const parsedGap = Number.parseFloat(carouselStyles.getPropertyValue('--pawmore-ugc-card-gap'));
          const cardGap = Number.isFinite(parsedGap) ? parsedGap : 28.8;
          const step = cardWidth + cardGap;
          const halfLength = cards.length / 2;

          viewport.scrollLeft = 0;
          viewport.scrollTop = 0;

          cards.forEach((card, index) => {
            let offset = index - activeIndex;
            if (offset > halfLength) offset -= cards.length;
            if (offset < -halfLength) offset += cards.length;

            const previousOffset = Number.parseFloat(card.dataset.pawmoreUgcOffset);
            const isWrapping = Number.isFinite(previousOffset) && Math.abs(previousOffset - offset) > 2;
            if (instant || isWrapping) card.classList.add('is-teleporting');

            card.style.setProperty('--pawmore-ugc-card-x', `${offset * step}px`);
            card.dataset.pawmoreUgcOffset = String(offset);

            const playToggle = card.querySelector('[data-pawmore-ugc-toggle]');
            const soundToggle = card.querySelector('[data-pawmore-ugc-sound]');
            const volumeSlider = card.querySelector('[data-pawmore-ugc-volume]');
            const isNearby = Math.abs(offset) <= 1;
            const isActive = index === activeIndex;
            if (isNearby) card.removeAttribute('aria-hidden');
            else card.setAttribute('aria-hidden', 'true');
            if (playToggle) playToggle.tabIndex = isActive ? 0 : -1;
            if (soundToggle) soundToggle.tabIndex = isActive ? 0 : -1;
            if (volumeSlider) volumeSlider.tabIndex = isActive ? 0 : -1;

            if (instant || isWrapping) {
              window.requestAnimationFrame(() => card.classList.remove('is-teleporting'));
            }
          });

          updateCardControls();
        };

        const selectVideo = (index, { play = true, restart = true } = {}) => {
          const nextIndex = normalizeIndex(index);
          if (nextIndex !== activeIndex) {
            videos.forEach((video, videoIndex) => {
              if (video && videoIndex !== activeIndex) video.pause();
            });
          } else {
            pauseVideos();
          }

          activeIndex = nextIndex;
          layoutCards();

          if (status) {
            const template = status.dataset.statusTemplate || 'Video [current] of [total] selected';
            status.textContent = template.replace('[current]', String(activeIndex + 1)).replace('[total]', String(cards.length));
          }

          if (play) {
            playActiveVideo({ restart, delay: prefersReducedMotion() ? 0 : 400 });
          }
        };

        cards.forEach((card, index) => {
          const video = videos[index];
          const playToggle = card.querySelector('[data-pawmore-ugc-toggle]');
          const soundToggle = card.querySelector('[data-pawmore-ugc-sound]');
          const volumeSlider = card.querySelector('[data-pawmore-ugc-volume]');

          if (video) {
            video.muted = true;
            video.defaultMuted = true;
            video.volume = 0.5;
            card.dataset.pawmoreUgcLastVolume = '0.5';
            primeFirstFrame(video);
            video.addEventListener('play', updateCardControls, { signal });
            video.addEventListener('playing', () => card.classList.add('has-played'), { signal });
            video.addEventListener('pause', updateCardControls, { signal });
            video.addEventListener('ended', updateCardControls, { signal });
            video.addEventListener('volumechange', updateCardControls, { signal });
          }

          playToggle?.addEventListener('click', () => {
            if (suppressNextClick) return;
            if (index !== activeIndex) {
              selectVideo(index);
              return;
            }

            if (!video) return;
            if (video.paused || video.ended) playActiveVideo();
            else video.pause();
          }, { signal });

          soundToggle?.addEventListener('click', (event) => {
            event.stopPropagation();
            if (!video) return;

            if (video.muted || video.volume <= 0) {
              const previousVolume = Number.parseFloat(card.dataset.pawmoreUgcLastVolume);
              video.volume = Number.isFinite(previousVolume) && previousVolume > 0 ? previousVolume : 0.5;
              video.muted = false;
            } else {
              card.dataset.pawmoreUgcLastVolume = String(video.volume || 0.5);
              video.muted = true;
            }

            updateCardControls();
          }, { signal });

          volumeSlider?.addEventListener('input', (event) => {
            if (!video) return;
            const nextVolume = Math.min(1, Math.max(0, Number.parseFloat(event.currentTarget.value) || 0));

            if (nextVolume > 0) {
              video.volume = nextVolume;
              video.muted = false;
              card.dataset.pawmoreUgcLastVolume = String(nextVolume);
            } else {
              video.muted = true;
            }

            updateCardControls();
          }, { signal });

          volumeSlider?.addEventListener('pointerdown', (event) => event.stopPropagation(), { signal });
          volumeSlider?.addEventListener('click', (event) => event.stopPropagation(), { signal });
        });

        previousButton?.addEventListener('click', () => selectVideo(activeIndex - 1), { signal });
        nextButton?.addEventListener('click', () => selectVideo(activeIndex + 1), { signal });

        viewport.addEventListener('pointerdown', (event) => {
          if (event.isPrimary === false) return;
          pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
        }, { passive: true, signal });

        viewport.addEventListener('pointerup', (event) => {
          if (!pointerStart || event.pointerId !== pointerStart.id) return;
          const deltaX = event.clientX - pointerStart.x;
          const deltaY = event.clientY - pointerStart.y;
          pointerStart = null;
          if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;

          suppressNextClick = true;
          selectVideo(activeIndex + (deltaX < 0 ? 1 : -1));
          window.setTimeout(() => {
            suppressNextClick = false;
          }, 0);
        }, { passive: true, signal });

        ['pointercancel', 'lostpointercapture'].forEach((eventName) => {
          viewport.addEventListener(eventName, () => {
            pointerStart = null;
          }, { passive: true, signal });
        });

        const handleResize = () => {
          if (resizeFrame) return;
          resizeFrame = window.requestAnimationFrame(() => {
            layoutCards({ instant: true });
            resizeFrame = null;
          });
        };

        window.addEventListener('resize', handleResize, { passive: true, signal });

        if (!prefersReducedMotion()) {
          if ('IntersectionObserver' in window) {
            intersectionObserver = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
                  if (!isInView) {
                    isInView = true;
                    playActiveVideo({ restart: true });
                  }
                } else if (!entry.isIntersecting || entry.intersectionRatio <= 0.05) {
                  if (isInView) {
                    isInView = false;
                    pauseVideos({ reset: true });
                  }
                }
              });
            }, { threshold: [0, 0.05, 0.35] });
            intersectionObserver.observe(viewport);
          } else {
            isInView = true;
            playActiveVideo({ restart: true });
          }
        }

        layoutCards({ instant: true });
        carousel.dataset.pawmoreUgcReady = 'true';

        instances.set(carousel, {
          destroy: () => {
            intersectionObserver?.disconnect();
            controller.abort();
            window.cancelAnimationFrame(resizeFrame);
            window.clearTimeout(playTimer);
            videos.forEach((video) => video?.pause());
            instances.delete(carousel);
            delete carousel.dataset.pawmoreUgcReady;
          }
        });
      });
    };

    const destroy = (root = document) => {
      root.querySelectorAll('[data-pawmore-ugc-carousel]').forEach((carousel) => {
        instances.get(carousel)?.destroy();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
